import { BaseError } from '@dynamic-labs-sdk/client';

export class TaprootAddressNotSupportedError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'taproot_address_not_supported',
      docsUrl: null,
      name: 'TaprootAddressNotSupportedError',
      shortMessage:
        'Taproot addresses are not supported for PSBT building. Only Native SegWit (P2WPKH) addresses are allowed.',
    });
  }
}
